export const combineMerge = (prevArr, currArr) => {
    return [...new Set([...prevArr, ...currArr])];
};
